import { render, staticRenderFns } from "./FxDesignation.vue?vue&type=template&id=096e07e6&"
import script from "./FxDesignation.vue?vue&type=script&lang=js&"
export * from "./FxDesignation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports